<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>调剂</el-breadcrumb-item>
        <el-breadcrumb-item>文章资讯</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">文章资讯</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="adjustAticleCreateVisible=!adjustAticleCreateVisible"
          >新建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="年份"
          prop="name"
        >
          <el-select
            v-model="query.year"
            placeholder="请选择"
            @change="fetchAdjustArticlelist(true)"
            clearable
            @clear="delete_value('year')"
          >
            <el-option label="2027" value="2027"></el-option>
            <el-option label="2026" value="2026"></el-option>
            <el-option label="2025" value="2025"></el-option>
            <el-option label="2024" value="2024"></el-option>
            <el-option label="2023" value="2023"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="院校名称"
          prop="college_name"
        >
          <el-select
            v-model="query.college_keyword"
            filterable
            collapse-tags
            placeholder="请选择"
            clearable
            @change="collegeChange"
            @clear="delete_value('college_keyword')"
          >
            <el-option
              v-for="(item, index) in $store.state.collegeList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="学院名称"
          prop="academy_keyword"
        >
          <el-select
            v-model="query.academy_keyword"
            placeholder="请选择"
            @change="fetchAdjustArticlelist(true)"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in academyList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
              <span>{{ `${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="专业名称"
          prop="major_keyword"
        >
          <el-select
            v-model="query.major_keyword"
            placeholder="请选择"
            filterable
            clearable
            @change="fetchAdjustArticlelist(true)"
          >
            <el-option
              v-for="(item, index) in majorList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="创建人"
          prop="college_name"
          v-if="isAdmin"
        >
          <el-select
            v-model="query.creator"
            placeholder="请选择"
            clearable
            @change="fetchAdjustArticlelist(true)"
          >
            <el-option
              v-for="(item, index) in $store.state.adminList"
              :key="index"
              :label="item.nickname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">调剂列表</h3>
        <el-form
          label-width="70px"
          size="small"
        >
        </el-form>
      </div>
      <div class="values">
        <el-table
          :data="tableData"
          border
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="year"
            label="年份"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校名称"
            align="center"
            width="170"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="专业名称"
            align="center"
            width="170"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{scope.row.major_code?`(${scope.row.major_code})${scope.row.major_name}`:'无'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="学院名称"
            align="center"
            width="170"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{scope.row.academy_code?scope.row.academy_name:'无'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="article_title"
            label="标题"
            align="center"
            show-overflow-tooltip
            width="350"
          >
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.article_title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.create_time).format("YYYY-MM-DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="操作"
            align="center"
            fixed="right"
            width="150"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openadjustAticleEditVisible(scope.row)"
              >编辑</el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="danger"
                :underline="false"
                @click="deleteItem(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="openadjustAticleEditVisible(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="deleteItem(scope.row)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <adjustAticleCreate
      :visible="adjustAticleCreateVisible"
      @close="adjustAticleCreateVisible=false"
      @submit="adjustAticleCreateSubmit"
    />
    <adjustAticleEdit
      :visible="adjustAticleEditVisible"
      @close="adjustAticleEditVisible=false"
      @submit="adjustAticleEditSubmit"
      :id="adjustAticleEditId"
    />
  </div>
</template>

<script>
import { adjustArticlelist, createAdjustArticle, editAdjustArticle, deleteAdjustArticle } from "@/api/adjust";
import adjustAticleCreate from "@/components/dialog/adjustAticle/adjustAticleCreate.vue";
import adjustAticleEdit from "@/components/dialog/adjustAticle/adjustAticleEdit.vue";
import { collegeMajorList, majorSubjectList, academyList } from "@/api/common";

export default {
  components: {
    adjustAticleCreate,
    adjustAticleEdit
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        user_type: 2,
      },
      pageTotal: 0,
      createDatetime: "",
      adjustAticleCreateVisible: false,// 创建弹窗
      adjustAticleEditVisible: false,// 编辑弹窗
      adjustAticleEditId: null,
      tableData: [],
      isAdmin: false,
      majorList: [],
      academyList: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.fetchAdjustArticlelist()
    this.$store.dispatch('getAdminList')
    let arr = JSON.parse(localStorage.getItem('admin_user')).roles.split(',') || []
    if (arr.findIndex(v => { return v == '10' }) == -1) {
      this.isAdmin = false
    } else {
      this.isAdmin = true
    }
  },
  methods: {
    fetchAdjustArticlelist(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      adjustArticlelist(this.query).then(res => {
        this.tableData = res.list || []
        this.pageTotal = res.count
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.fetchAdjustArticlelist();
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.fetchAdjustArticlelist();
    },
    // 创建弹窗关闭
    adjustAticleCreateClose() {
      this.adjustAticleCreateVisible = false
    },
    adjustAticleCreateSubmit({ obj }) {
      createAdjustArticle(obj).then(res => {
        this.adjustAticleCreateVisible = false
        this.fetchAdjustArticlelist()
      })
    },
    adjustAticleEditSubmit({ obj }) {
      editAdjustArticle(obj).then(res => {
        this.adjustAticleEditVisible = false
        this.fetchAdjustArticlelist()
      })
    },
    openadjustAticleEditVisible(item) {
      this.adjustAticleEditId = item.id
      this.adjustAticleEditVisible = !this.adjustAticleEditVisible
    },
    deleteItem(item) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAdjustArticle({ id: item.id }).then((res) => {
            this.$nextTick(() => {
              this.fetchAdjustArticlelist();
            });
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "提示",
            message: "已取消删除",
          });
        });
    },
    // 接口筛选后端不能接收空值，所以在清除的时候去删掉这个属性
    delete_value(value) {
      this.$delete(this.query, value)
      this.fetchAdjustArticlelist()
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
    // 录取院校选择后要搜索相对应的院校名称
    collegeChange(e) {
      this.fetchAdjustArticlelist(true);
      if (e) {
        this.getMajor(e);
        this.getAcademy(e)
      }

    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || [];
      });
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || [];
      });
    },
  }
};
</script>

<style lang="less" scoped>
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
}
.item-table-column {
  text-align: left;
}
</style>